import React, { useEffect, useState } from 'react';
import { ParentContainer } from '../../styles';
import { StepHeader, CommonButton, ModalFactory, InstaremAvatar } from '@Components';
import { CLOSE_POPUP_ICON, DOCUMENT_ID_ICON_DUAL_TONE } from '@Images';
import { IStore } from '../../../../store.type';
import { connect } from 'react-redux';
import {
  authoriseForexTransaction,
  changeNiumForexScreen,
  niumForexTransactionComputation,
  storeTransactionDetails,
  getNiumForexTransactionDetails
} from '@Redux/actions/nium-forex';
import {
  ButtonContainer,
  ConfirmationTextContainer,
  CouponContainer,
  DiscountBannerContainer,
  PaymentDetailsContainerDiv,
  RecipientInfoContainer
} from './styles';

import PaymentDetailsContainer from '../../utils/payment-details-container';
import { PaymentReviewModal, CouponForm, RecipientInfoModal } from './components';
import { NF_SCREENS } from '../../root/screenConstants';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import { formatComputedData, getComputedCurrency } from './utils';
import { formatAmount } from '@Utils/library';
import { IPaymentReviewScreenProps } from '../../utils/interface';
import { TRANSACTION_SUMMARY_SCREEN, screenSettings, totalSteps } from '../../utils/constants';
import CancelPaymentModal from '../../utils/cancel-payment-modal';
import { NF_AUTHORISE_TRANSACTION } from '@Utils/constants/eventsConstants';
import { FLOW_TYPE } from '@Utils/constants';
import { logEvent } from '../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../utils/events/eventsConstants';

const PaymentReview: React.FC<IPaymentReviewScreenProps> = ({
  changeNiumForexScreen,
  instaremFxRate,
  destinationAmount,
  destinationCurrency,
  sourceAmount,
  netSourceAmount,
  transactionFeeAmount,
  taxAmount1,
  taxAmount2,
  taxAmount3,
  netTaxAmount,
  paymentMethodFeeAmount,
  netOfFeeAmount,
  payoutMethodFeeAmount,
  couponAmount,
  couponCode,
  isCouponApplied,
  sourceCurrency,
  storeTransactionDetails,
  activateLoader,
  disableLoader,
  beneficiaryName,
  beneficiaryBankName,
  reasonForTransfer,
  sourceOfFunds,
  fxRate,
  taxType1,
  taxType2,
  taxType3,
  marginAmount,
  marginPercent,
  transactionFeePercent,
  paymentMethodFeePercent,
  additionalInfo,
  transactionId,
  senderBankName,
  senderName,
  authoriseForexTransaction,
  getNiumForexTransactionDetails,
  remittanceType
}) => {
  const stepperData = screenSettings[NF_SCREENS.transaction_summary as keyof typeof screenSettings];
  const [showTax, setShowTax] = useState<boolean>(false);
  const [showFees, setShowFees] = useState<boolean>(false);
  const [isTransactionInfoUpdate, setisTransactionInfoUpdate] = useState<boolean>(false);
  const transactionConfig = {
    sourceAmount,
    destinationAmount,
    sourceCurrency: 'INR',
    destinationCurrency,
    transactionFeeAmount,
    computedData: {
      tax_amount_1: taxAmount1,
      tax_amount_2: taxAmount2,
      tax_amount_3: taxAmount3,
      net_tax_amount: netTaxAmount,
      payment_method_fee_amount: paymentMethodFeeAmount,
      net_of_fee_amount: netOfFeeAmount,
      payout_method_fee_amount: payoutMethodFeeAmount
    },
    instarem_fx_rate: instaremFxRate,
    netSourceAmount,
    couponAmount
  };

  const handleAuthoriseTransfer = async () => {
    activateLoader?.();
    let payload = null;
    if (isTransactionInfoUpdate) {
      payload = {
        is_authorised_transaction: true,
        is_transaction_info_update: true,
        instarem_fx_rate: instaremFxRate,
        gross_source_amount: sourceAmount,
        net_source_amount: netSourceAmount,
        transaction_fee_amount: transactionFeeAmount,
        tax_amount_1: taxAmount1,
        tax_amount_2: taxAmount2,
        tax_amount_3: taxAmount3,
        destination_amount: destinationAmount,
        net_tax_amount: netTaxAmount,
        payment_method_fee_amount: paymentMethodFeeAmount,
        net_of_fee_amount: netOfFeeAmount,
        coupon_code: couponCode,
        coupon_amount: couponAmount,
        fx_rate: fxRate,
        margin_percent: marginPercent,
        transaction_fee_percent: transactionFeePercent,
        tax_type_1: taxType1,
        tax_type_2: taxType2,
        tax_type_3: taxType3,
        additional_info: additionalInfo,
        payment_method_fee_percent: paymentMethodFeePercent,
        margin_amount: marginAmount
      };
    } else {
      payload = {
        is_authorised_transaction: true
      };
    }
    const response = await authoriseForexTransaction?.(payload, transactionId);
    if (response?.success) {
      const ctData = {
        pageNme: NF_SCREENS.transaction_summary,
        destinationCurrency,
        couponCode
      };
      logEvent(NF_AUTHORISE_TRANSACTION, FLOW_TYPE.TRANSACTION, ctData, LOG_TYPE.CLEVER_TAP);
      changeNiumForexScreen?.(NF_SCREENS.acknowledgement);
    }

    disableLoader?.();
  };

  const getTransactionDetails = async () => {
    activateLoader?.();
    const response = await getNiumForexTransactionDetails?.(transactionId);
    if (response?.data?.success) {
      const payload = formatComputedData(response?.data?.data);
      const additionalInfo = {
        remittanceType: response?.data?.data?.remittance_type,
        sourceOfFunds: response?.data?.data?.source_of_funds,
        reasonForTransfer: response?.data?.data?.reason_for_transfer
      };
      storeTransactionDetails?.({ ...payload, ...additionalInfo });
    }
    disableLoader?.();
  };
  useEffect(() => {
    getTransactionDetails();
    // eslint-disable-next-line
  }, []);

  const handleClearCoupon = async () => {
    const { sourceAmount: updatedAmount, isError } = await getComputedCurrency(
      sourceAmount,
      '',
      destinationCurrency,
      null,
      activateLoader,
      disableLoader,
      sourceCurrency,
      destinationCurrency,
      storeTransactionDetails,
      reasonForTransfer,
      sourceOfFunds,
      remittanceType
    );
    if (updatedAmount && updatedAmount !== netSourceAmount) setisTransactionInfoUpdate(true);
    if (!isError) {
      const ctData = {
        pageNme: NF_SCREENS.transaction_summary,
        destinationCurrency,
        couponCode
      };
      logEvent(NF_AUTHORISE_TRANSACTION, FLOW_TYPE.TRANSACTION, ctData, LOG_TYPE.CLEVER_TAP);
    }
  };

  const handleCalculatorFieldChange = (value: boolean) => {
    if (value) setisTransactionInfoUpdate(value);
  };

  const handleCouponClick = () => {
    if (isCouponApplied) {
      handleClearCoupon();
    } else {
      handleModalTrigger(
        PaymentReviewModal,
        CouponForm,
        { heading: TRANSACTION_SUMMARY_SCREEN.couponCode.heading, isCenter: true },
        { fieldChangeCallback: handleCalculatorFieldChange }
      );
    }
  };

  const handleCloseTransactionSummary = async () => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <CancelPaymentModal
          onContinue={() => onClose(true)}
          postPan={true}
          onConfirm={() => {
            changeNiumForexScreen?.(NF_SCREENS.send_money);
            onClose(true);
          }}
        />
      ),
      'center-modal insta-modal',
      true
    );
  };
  const handleModalTrigger = async (Parent: any, Child: any, props: any, childProps: any) => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <Parent {...props} onClose={onClose}>
          <Child {...childProps} onClose={onClose}></Child>
        </Parent>
      ),
      'nium-forex send-money-details insta-modal center-modal',
      true
    );
  };

  const handleBreakUpClick = (event: React.SyntheticEvent<EventTarget>) => {
    event.stopPropagation();
    setShowTax(!showTax);
  };

  const handleShowFees = (event: React.SyntheticEvent<EventTarget>) => {
    event.stopPropagation();
    setShowFees(!showFees);
  };
  return (
    <ParentContainer padding={[30, 0, 48, 0]}>
      <div className="navigationContainer">
        <img
          src={CLOSE_POPUP_ICON}
          className="closeButton"
          alt="close"
          onClick={handleCloseTransactionSummary}
        />
      </div>
      <StepHeader
        heading={TRANSACTION_SUMMARY_SCREEN.header}
        headerLogo={DOCUMENT_ID_ICON_DUAL_TONE}
        stepNumber={stepperData?.stepNumber}
        totalSteps={totalSteps}
        subHeading={TRANSACTION_SUMMARY_SCREEN.subHeading}
      />
      <RecipientInfoContainer>
        <div className="transaction-info-container">
          <InstaremAvatar name={senderName} flagCode={sourceCurrency} />
          <div className="transaction-info-sender pb-16">
            <span className="font-12 font-text-grey line-height-16">You send</span>
            <span className="font-24 font-black line-height-38">
              {`${formatAmount(sourceAmount)} ${sourceCurrency}`}
            </span>
            <span className="font-14 font-text-grey line-height-18">{`Bank Transfer | ${senderBankName}`}</span>
          </div>
        </div>
        {/* Beneficiary section */}
        <div className="transaction-info-container">
          <InstaremAvatar name={beneficiaryName} flagCode={destinationCurrency} />
          <div className="transaction-info-receiver">
            <span className="font-12 font-text-grey line-height-16">They get</span>
            <span className="font-24 font-black line-height-38">{`${formatAmount(
              destinationAmount
            )} ${destinationCurrency}`}</span>
            <span className="font-14 font-text-grey line-height-18">
              {`Bank Deposit | ${beneficiaryBankName}`}
            </span>
            <span
              className="font-brand-blue font-700 pointer-cursor line-height-26"
              onClick={() =>
                handleModalTrigger(
                  PaymentReviewModal,
                  RecipientInfoModal,
                  { heading: TRANSACTION_SUMMARY_SCREEN.recipientInfo.heading, isCenter: false },
                  {}
                )
              }
            >
              Details
            </span>
          </div>
        </div>
      </RecipientInfoContainer>

      <DiscountBannerContainer>
        <div className="discount-banner">{isCouponApplied ? 'Discount Applied' : 'Discount'}</div>
        <div className="triangle"></div>
      </DiscountBannerContainer>
      <CouponContainer>
        <div className="coupon-info-text-container">
          <span className="font-black font-700 font-14 line-height-26 font-bold">
            {isCouponApplied ? `${couponAmount} ${sourceCurrency} off` : 'Have a coupon?'}
          </span>
          <span className="font-12 line-height-16">
            {isCouponApplied ? 'With a coupon code' : 'Apply code here'}
          </span>
        </div>
        <span
          onClick={handleCouponClick}
          className="font-brand-blue font-700 font-14 pointer-cursor line-height-26 font-bold"
        >
          {isCouponApplied ? 'Clear' : 'Apply'}
        </span>
      </CouponContainer>

      <PaymentDetailsContainerDiv>
        <PaymentDetailsContainer
          transactionConfig={transactionConfig}
          handleBreakUpClick={handleBreakUpClick}
          handleShowFees={handleShowFees}
          showFees={showFees}
          showTax={showTax}
          isPaymentScreen={true}
        />
      </PaymentDetailsContainerDiv>
      <ConfirmationTextContainer>
        <p>
          By proceeding I confirm that I have reviewed the transfer and will pay for it from my own{' '}
          <span className="bold-text">savings</span> bank account.
          <span className="bold-text">
            {' '}
            If paid from another account, my transfer will be cancelled and refunded.
          </span>
        </p>
      </ConfirmationTextContainer>
      <ButtonContainer>
        <CommonButton
          text={TRANSACTION_SUMMARY_SCREEN.btnAuthoriseMessage}
          onClick={handleAuthoriseTransfer}
          width={450}
        />
      </ButtonContainer>
    </ParentContainer>
  );
};
const mapStateToProps = (state: IStore) => {
  const {
    rootReducer: {
      niumForexReducer: {
        transactionDetails: {
          destinationCurrency,
          instaremFxRate,
          sourceAmount,
          netSourceAmount,
          sourceCurrency,
          transactionFeeAmount,
          taxAmount1,
          taxAmount2,
          taxAmount3,
          destinationAmount,
          netTaxAmount,
          paymentMethodFeeAmount,
          netOfFeeAmount,
          payoutMethodFeeAmount,
          couponCode,
          couponAmount,
          beneDetails: { name: beneficiaryName, bankName: beneficiaryBankName },
          remitterDetails: { remitterName: senderName, remitterBankName: senderBankName },
          reasonForTransfer,
          sourceOfFunds,
          fxRate,
          taxType1,
          taxType2,
          taxType3,
          marginAmount,
          marginPercent,
          transactionFeePercent,
          paymentMethodFeePercent,
          additionalInfo,
          transactionId,
          remittanceType
        }
      }
    }
  } = state;
  return {
    instaremFxRate,
    destinationAmount,
    destinationCurrency,
    sourceCurrency,
    sourceAmount,
    netSourceAmount,
    transactionFeeAmount,
    taxAmount1,
    taxAmount2,
    taxAmount3,
    netTaxAmount,
    paymentMethodFeeAmount,
    netOfFeeAmount,
    payoutMethodFeeAmount,
    couponAmount,
    isCouponApplied: couponCode ? true : false,
    niumForexTransactionComputation,
    beneficiaryName,
    beneficiaryBankName,
    reasonForTransfer,
    sourceOfFunds,
    fxRate,
    taxType1,
    taxType2,
    taxType3,
    marginAmount,
    marginPercent,
    transactionFeePercent,
    paymentMethodFeePercent,
    additionalInfo,
    transactionId,
    senderBankName,
    senderName,
    couponCode,
    remittanceType
  };
};
export default connect<any, any, any, IStore>(mapStateToProps, {
  changeNiumForexScreen,
  storeTransactionDetails,
  activateLoader,
  disableLoader,
  authoriseForexTransaction,
  getNiumForexTransactionDetails
  //@ts-ignore
})(PaymentReview);
